// ── Glass renderer (Phase 2A) ──
// Owns #glass-canvas (z-30, above the glass-plate). Renders GlassBitEcho:
// the orange square that always sits at the wordmark "i" position, regardless
// of scroll. While FieldBit (in field-renderer) descends, this echo stays put.
// Locked Bit-as-pair mechanic per D24.

export interface LogoAnchor {
  x: number;
  y: number;
  size: number;
}

export class GlassRenderer {
  private canvas: HTMLCanvasElement;
  private ctx: CanvasRenderingContext2D;
  private dpr: number = 1;
  private logo: LogoAnchor = { x: 0, y: 0, size: 14 };

  constructor(canvasEl: HTMLCanvasElement) {
    this.canvas = canvasEl;
    const ctx = canvasEl.getContext('2d', { alpha: true });
    if (!ctx) throw new Error('Canvas 2D context unavailable');
    this.ctx = ctx;
    this.resize();
    window.addEventListener('resize', () => this.resize());
  }

  private resize(): void {
    this.dpr = Math.min(2, window.devicePixelRatio || 1);
    const w = window.innerWidth;
    const h = window.innerHeight;
    this.canvas.width = Math.round(w * this.dpr);
    this.canvas.height = Math.round(h * this.dpr);
    this.canvas.style.width = `${w}px`;
    this.canvas.style.height = `${h}px`;
    this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
  }

  setLogoAnchor(anchor: LogoAnchor): void {
    this.logo = anchor;
  }

  getLogoAnchor(): LogoAnchor {
    return this.logo;
  }

  draw(): void {
    // Phase 2 (May 4 2026): canvas-based GlassBitEcho removed. The CSS
    // .brand-i-dot is the brand mark on Layer 1 (always present, scrolls
    // with the fixed nav). A canvas duplicate at the same coords confused
    // the read of the "main character" being separate from the wordmark.
    // The class stays for Phase 2C+ (Bit echo on backscroll, currently
    // satisfied by the CSS dot + the eyebrow-anchored FieldBit).
    const w = window.innerWidth;
    const h = window.innerHeight;
    this.ctx.clearRect(0, 0, w, h);
  }
}
